"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramTypes = exports.constants = void 0;
exports.constants = {
    POD_BASE_URL: 'https://api.pod.ir/',
    POD_AUTH_BASE_URL: 'https://accounts.pod.ir/',
    STORAGE_DATA_KEY: 'POD_BOX_DATA',
    TOKEN_ISSUER: '1',
    TOKEN_KEY: 'access_token',
    REFRESH_TOKEN_KEY: 'refresh_token',
    EXPIRES_IN_KEY: 'expires_in',
    CODE_VERIFIER_KEY: 'code_verifier',
    CLIENT_ID_KEY: 'client_id',
    CLOSE_MODE_KEY: 'closeMode',
    CLOSE_MESSAGE_KEY: 'closeMessage',
    CLOSE_ACTION_KEY: 'closeAction',
    REDIRECT_URL_KEY: 'redirect_url',
};
exports.paramTypes = [
    exports.constants.TOKEN_KEY,
    exports.constants.REFRESH_TOKEN_KEY,
    exports.constants.CLIENT_ID_KEY,
    exports.constants.CODE_VERIFIER_KEY,
    exports.constants.CLOSE_MODE_KEY,
    exports.constants.CLOSE_MESSAGE_KEY,
    exports.constants.CLOSE_ACTION_KEY,
    exports.constants.REDIRECT_URL_KEY,
    exports.constants.EXPIRES_IN_KEY,
];
//# sourceMappingURL=__constants__.js.map